import { render, staticRenderFns } from "./SetSecretQuestion.vue?vue&type=template&id=7deb8017&scoped=true&"
import script from "./SetSecretQuestion.vue?vue&type=script&lang=js&"
export * from "./SetSecretQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SetSecretQuestion.vue?vue&type=style&index=0&id=7deb8017&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb8017",
  null
  
)

export default component.exports